import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import {
  Autocomplete,
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  ThemeProvider,
  Typography,
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomSnackbar from "../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import SearchButton from "../../../newTestPrep/newComponent/NewButtonComp/SearchButton";
import CustomTextFieldComp from "../../../newTestPrep/newComponent/customTextFieldComp";
import CustomAutocompleteComp from "../../../newTestPrep/newComponent/AutocompleteComp";
import HeadingCard from "../../../newTestPrep/newComponent/NewCardsComp/HeadingCard";
import MainCard from "../../../components/Maincard";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import {
  emailWithRequiredPattern,
  namePattern,
  nameWithRequiredPattern,
  validateMobile,
  validateRequiredMobile,
} from "../../../utils/formatTime";
import StyledTableContainer from "../../../newTestPrep/newComponent/TableContainer";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../../newTestPrep/newComponent/TableCustomeComp/CustomNoRowsOverlay";
import AddWalkinForm from "./AddAppoinmentWalkinForm";
import CustomPopup from "../../../components/CustomPopup";
import AddAppoinmentWalkinForm from "./AddAppoinmentWalkinForm";
import CreateNewAppoinment from "./CreateNewAppoinment";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

function AddWalkIn() {
  const navigate = useNavigate();

  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const branchId=localStorage.getItem("branch")
  const [selectedType, setSelectedType] = useState("");
  const [emailField, setEmailField] = useState(null);
  const [isdCode, setIsdCode] = useState(null);
  const [mobileField, setMobileField] = useState(null);
  const [summaryData, setSummaryData] = useState([]);

  const [enquiryDetails, setEnquiryDetails] = useState(null);
  const [enquiryPersonalDetails, setEnquiryPersonalDetails] = useState(null);
  const [searching, setSearching] = useState(false);
   const [showForm, setShowForm] = useState(false);

  const [walkInStatus, setWalkInStatus] = useState("direct");

  const [isSavingLoading, setIsSavingLoading] = useState(false);

  const [countries, setCountries] = useState([]);
  const [countriesList, setCountriesList] = useState([]);
  const [openWalkinForm, setOpenWalkinForm] = useState(false);
  const [openNewWalkinForm, setOpenNewWalkinform] =useState(false)

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    // Fetch menu items using the fetch function
    fetch(`${API_ENDPOINT}country`)
      .then((response) => response.json())
      .then((data) => {
        const sortedData = [...data].sort(
          (a, b) => a.phone_code - b.phone_code
        );
        const uniqueArray = sortedData.filter(
          (obj, index, self) =>
            index === self.findIndex((t) => t.phone_code === obj.phone_code)
        );
        setCountriesList(data);
        setCountries(uniqueArray);

        console.log(data);
      })
      .catch((error) => {
        console.error("Error fetching country:", error);
      });
  }, []);

  const handleChangeType = (criteria) => {
    setMobileField(null);
    setIsdCode(null);
    setEmailField(null);
    setSelectedType(criteria);
  };

  //handle search functionality
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^[0-9]{10}$/;

  const handleSearch = async () => {

    if (selectedType === "email" && !emailRegex.test(emailField)) {
      showSnackbar("Enter a valid email.", "error");
      return;
    }

    if (selectedType === "mobile") {
      const mobileError = validateMobile(isdCode, mobileField, true);
      if (mobileError) {
        showSnackbar(mobileError, "error");
        return;
      }
    }

    setSearching(true);
    const requestData = {
      type: selectedType,
      email: emailField,
      mobile_country_code: isdCode,
      mobile: mobileField,
      user_id :parseInt(userId)
    };

    try {
      // Make a POST request to your API endpoint
      const response = await fetch(
        `${API_ENDPOINT}advisordashboard/getenquirydetail-registerwalkin`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );
      // console.log(response);
      const responseData = await response.json();

      if (response.status === 200) {
      
        // setEnquiryDetails(responseData.enquiry);
         setEnquiryPersonalDetails(responseData.enq_personal_detail);
        //  setWalkInStatus(responseData.walkInStatus);
        // setSelectedSourceType(responseData?.enquiry?.lead_source_type_id);
        setSummaryData(responseData);
        setSearching(false);
           setShowForm(true);
      } else if (response.status === 404) {
        showSnackbar(responseData?.message, "error");
        setSearching(false);
        setSummaryData([]);
        setWalkInStatus(responseData.walkInStatus);
            setShowForm(true)

   
         setEnquiryPersonalDetails(null);
     
      } else if (response.status === 400) {
        showSnackbar(responseData?.message, "error");
        setSearching(false);
         showSnackbar(responseData?.message, "error");
        setSearching(false);
        setSummaryData([]);
        setWalkInStatus(responseData.walkInStatus);
            setShowForm(true)

   
         setEnquiryPersonalDetails(null);
      } else {
        showSnackbar("API Request Failed:", "error");
        setSearching(false);
        // setShowNoEnquiryPopup(true);
      }
    } catch (error) {
      console.error("An error occurred during the API request:", error);
      showSnackbar("An error occurred during the API request", "error");
      setSearching(false);
    }
  };

  const handleOpenForm = (enquiryId) => {
    setOpenWalkinForm(true);
  };

  const handleCloseForm = () => {
    setOpenWalkinForm(false);
  };

  const handleOpenNewForm = () => {
    setOpenNewWalkinform(true);
  };

  const handleCloseNewForm = () => {
    setOpenNewWalkinform(false);
  };


  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.value,
      renderCell: (params) => (
        <div  >
          <Button onClick={() => handleCreateAppoinment(params?.row?.id)} variant="contained" size="small" color="primary" disabled={params?.row?.is_editable ===false }>
            Create Appoinment
          </Button>
        </div>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      width: 200,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.first_name || ""} ${params.row?.last_name}`,

      renderCell: (params) => (
        <div>
          {params.row?.first_name} {params.row?.last_name}
        </div>
      ),
    },

    {
      field: "mobile",
      headerName: "Mobile",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.value,
      renderCell: (params) => (
        <div>
          {params.row?.mobile_country_code}
          {userRole === "advisor" || userRole === "trainer"
            ? params.row?.mobile?.replace(/.(?=.{4,}$)/g, "*")
            : params.row?.mobile}
        </div>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.value,
      sortComparator: (v1, v2) => {
        const num1 = parseFloat(v1); // Convert to a number
        const num2 = parseFloat(v2); // Convert to a number
        return num1 - num2; // Numeric comparison
      },
      renderCell: (params) => {
        const email = params.row?.email || "";

        if (email.length <= 5) return email; // not enough to mask

        const start = email.slice(0, 2);
        const end = email.slice(-3);
        return `${start}***${end}`;
      },
    },
    {
      field: "service",
      headerName: "Service",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.row?.service_id?.service_name || "",
      renderCell: (params) => (
        <div> {params.row?.service_id?.service_name}</div>
      ),
    },
    {
      field: "sub_service",
      headerName: "Sub Service",
      width: 150,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.row?.sub_service_id?.name,
      renderCell: (params) => <div>{params.row?.sub_service_id?.name} </div>,
    },
    {
      field: "assign_to",
      headerName: "Assign To",
      width: 200,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        ` ${params.row?.assign_to?.first_name}  ${params.row?.assign_to?.last_name}`,
      renderCell: (params) => (
        <div>
          {params.row?.assign_to?.first_name}{" "}
          {params.row?.assign_to?.last_name}{" "}
        </div>
      ),
    },
  ];

  const handleCreateAppoinment = async (enquiryId) => {
    setSearching(true);

    const requestData = {
      user_id: parseInt(userId),
      enquiry_id: enquiryId,
    };

    try {
      // Make a POST request to your API endpoint
      const response = await fetch(
        ` ${API_ENDPOINT}advisordashboard/registerwalkin-by-enquiryId`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      const responseData = await response.json();

      if (response.status === 200) {
        // setShowForm(true);
        setEnquiryDetails(responseData.enquiry);
        // setEnquiryPersonalDetails(responseData.enquiry_personal_details);
        setWalkInStatus(responseData.walkInStatus);
        // setSelectedSourceType(responseData?.enquiry?.lead_source_type_id);

        setSearching(false);
        handleOpenForm();
      } else if (response.status === 401) {
        showSnackbar(responseData?.message, "error");
        setSearching(false);
      } else if (response.status === 400) {
        showSnackbar(responseData?.message, "error");
        setSearching(false);
      } else {
        showSnackbar("API Request Failed:", "error");
        setSearching(false);
        // setShowNoEnquiryPopup(true);
      }
    } catch (error) {
      console.error("An error occurred during the API request:", error);
      showSnackbar("An error occurred during the API request", "error");
      setSearching(false);
    }
  };

  return (
    <>
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} sm={4} md={3} lg={2}>
          <HeadingCard label="Register Walk In" />
        </Grid>
        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={6} md={3} lg={1.7}>
                <RadioGroup row>
                  <FormControlLabel
                    value="cash"
                    control={
                      <Radio
                        size="large"
                        color="primary"
                        onClick={() => handleChangeType("email")}
                      />
                    }
                    label="Email"
                  />
                  <FormControlLabel
                    value="percentage"
                    control={
                      <Radio
                        size="large"
                        onClick={() => handleChangeType("mobile")}
                      />
                    }
                    label="Mobile"
                  />
                </RadioGroup>
              </Grid>

              {selectedType === "email" && (
                <Grid item xs={12} sm={6} lg={4}>
                  <TextField
                    size="small"
                    value={emailField}
                    onChange={(e) => setEmailField(e.target.value)}
                    InputProps={{
                      style: { borderRadius: "10px" },
                    }}
                    fullWidth
                    label="Email"
                  />
                </Grid>
              )}

              {selectedType === "mobile" && (
                <Grid item xs={12} md={4} lg={4} container>
                  <Grid item xs={4} md={4} lg={4}>
                    <TextField
                      select
                      size="small"
                      InputProps={{
                        style: { borderRadius: "10px" },
                      }}
                      fullWidth
                      label="ISD Code"
                      onChange={(e) => setIsdCode(e.target.value)}
                    >
                      {countries.map((country) => (
                        <MenuItem
                          key={country.phone_code}
                          value={country.phone_code}
                        >
                          {country.phone_code}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={8} md={8} lg={8}>
                    <TextField
                      size="small"
                      InputProps={{
                        style: { borderRadius: "10px" },
                      }}
                      onChange={(e) => setMobileField(e.target.value)}
                      fullWidth
                      label="Mobile"
                    />
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12} sm={6} lg={4}>
                <SearchButton showIcon={true} onClick={handleSearch}>
                  Search
                </SearchButton>
              </Grid>
            </Grid>
          </MainCard>
        </Grid>

      {showForm && ( 
          <Grid item xs={12}>
            <MainCard>
              <Grid container spacing={2}>
                <Grid item xs={12} textAlign="end">
                  <Button variant="contained" size="small" color="primary" onClick={handleOpenNewForm}>
                    Create New Enquiry
                  </Button>
                </Grid>


  {summaryData?.enquiry_list?.length > 0 ?  (

<Grid item xs={12}>
                <DataGrid
                  rows={summaryData?.enquiry_list}
                  columns={columns}
                  autoHeight
                  slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 25,
                      },
                    },
                  }}
                
                  pageSizeOptions={[25, 50, 100]}
                />
                </Grid>

                ): <Grid item xs={12}> <Typography variant="h4" textAlign='center'>No Enquiry Exists</Typography></Grid> }
              </Grid>
            </MainCard>
          </Grid>
        )}
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <CustomPopup
        open={openWalkinForm}
        onClose={handleCloseForm}
        component={
          <AddAppoinmentWalkinForm
            enquiryDetails={enquiryDetails}
            walkInStatus={walkInStatus}
            isSavingLoading={isSavingLoading}
            setIsSavingLoading={setIsSavingLoading}
            isdCode={isdCode}
            mobileField={mobileField}
            emailField={emailField}
          />
        }
        title="Create Appointment"
        maxWidth="lg"
        showDivider={true}
      />

       <CustomPopup
        open={openNewWalkinForm}
        onClose={handleCloseNewForm}
        component={
          <CreateNewAppoinment
           setIsSavingLoading={setIsSavingLoading}
            walkInStatus="direct"
          enquiryPersonalDetails={enquiryPersonalDetails}
            isdCode={isdCode}
            mobileField={mobileField}
            emailField={emailField}
          />
        }
        title="Create New Enquiry"
        maxWidth="lg"
        showDivider={true}
      />

      <Backdrop open={searching} style={{ zIndex: 999 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Backdrop open={isSavingLoading} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} marginRight={2}>
          Saving Details
        </Typography>
        <CircularProgress color="primary" />
      </Backdrop>
    </>
  );
}

export default AddWalkIn;
